var contentToSlide, currentSliderId, contentToSlideLength;

var activeLeft = [],
activeCenter = [],
activeRight = [];

function getNextToSlideIn( clickDirection ) {
    var next;
    if ( clickDirection == 'left' ) {
        next = activeRight[currentSliderId]+1;
        if ( next >= contentToSlideLength  ) {
            next = 0;
        }
    } else {
        next = activeLeft[currentSliderId]-1;
        if ( next < 0  ) {
            next = contentToSlideLength-1;
        }
    }

    return next;
}

function setNextActiveSlides( clickDirection ) {
    if ( clickDirection == 'left' ) {
        activeLeft[currentSliderId] = activeCenter[currentSliderId];
        activeCenter[currentSliderId] = activeRight[currentSliderId];
        activeRight[currentSliderId] = getNextToSlideIn('left');
    } else {
        activeRight[currentSliderId] = activeCenter[currentSliderId];
        activeCenter[currentSliderId] = activeLeft[currentSliderId];
        activeLeft[currentSliderId] = getNextToSlideIn('right');
    }
}

function slideLeft(obj) {
    contentToSlide = obj.parentNode.parentNode.parentNode.getElementsByClassName('slide-content');
    contentToSlideLength = contentToSlide.length;
    var next = getNextToSlideIn('right');
    contentToSlide[next].className = 'slide-content position-left-outside';
    setTimeout(function(){
        contentToSlide[activeLeft[currentSliderId]].className = 'slide-content position-center';
        contentToSlide[activeCenter[currentSliderId]].className = 'slide-content position-right';
        contentToSlide[activeRight[currentSliderId]].className = 'slide-content slide-out-right';
        contentToSlide[next].className = 'slide-content position-left';
        setNextActiveSlides( 'right' );
    }, 100);
}

function slideRight(obj) {
    contentToSlide = obj.parentNode.parentNode.parentNode.getElementsByClassName('slide-content');
    contentToSlideLength = contentToSlide.length;

    var next = getNextToSlideIn('left');
    contentToSlide[next].className = 'slide-content position-right-outside';
    setTimeout(function(){
        contentToSlide[activeLeft[currentSliderId]].className = 'slide-content slide-out-left';
        contentToSlide[activeCenter[currentSliderId]].className = 'slide-content position-left';
        contentToSlide[activeRight[currentSliderId]].className = 'slide-content position-center';
        contentToSlide[next].className = 'slide-content position-right';
        setNextActiveSlides( 'left' );
    }, 100);
}


function teaserSlideAnimation( obj ) {
    currentSliderId = parseInt(obj.dataset.sliderId);

    if ( obj.className == 'left-button' ) {
        slideLeft(obj);
    } else {
        slideRight(obj);
    }
}

var a, b, counter=[1, 1];

window.addEventListener("load", function(e) {
    var teaserslider = document.getElementsByClassName('teaserslider');

    for (a=0; a<teaserslider.length; a++) {

        var slide_content_count = teaserslider[a].children[0].children[1].childElementCount,
            button = teaserslider[a].querySelectorAll('button');

        for (b=0; b<button.length; b++) {
            if ( slide_content_count <= 3 ) {
                button[b].classList.add('displayNone');
                $(teaserslider).find('.slider-body').addClass('slider-body--noButton');
            } else {
                button[b].setAttribute("data-slider-id", a); 
                button[b].addEventListener('click', function() {
                    teaserSlideAnimation(this);
                });
                $(teaserslider).find('teaser-body').removeClass('teaser-body--noButton');
            }
        }

        activeLeft[a] = 0;
        activeCenter[a] = 1;
        activeRight[a] = 2;
    }   
});
